import { jsx as t, jsxs as f } from "react/jsx-runtime";
import { useRef as F, useState as W, useEffect as q } from "react";
import { j as a, k as e, C as L, a0 as z, G as M, am as X, aN as A, aB as B, i as U, aO as J, a5 as G, s as K, aP as Z, ak as H, al as Y, aQ as ee, f as te, Q as ne, t as se, S as oe } from "./helpers-458d7e27.js";
import { T as ae } from "./TextHeaderInner-7887aa3a.js";
import y from "clsx";
import { M as R } from "./MinimalImageFrame-6a4f63a6.js";
import { M as re } from "./MinimalTextGroup-0c5b3b52.js";
import { u as le, p as me, s as k } from "./PpReactLoadingSpinner-1a2407d0.js";
import "@emotion/react";
import "@paypalcorp/pp-react-theme";
import "@paypalcorp/pp-react-icons";
import "react-dom";
import "./TextGroup-dd19925e.js";
import "./AppDownload-79ac7787.js";
import "./pp-react-text-input.esm-853a9847.js";
import "./card-renderer-3ad4b108.js";
import "./PpReactCurrencyInput-cfa9b61d.js";
const ie = {
  top: {
    options: {
      columnStart: a.leftEdge,
      columnEnd: a.rightEdge
    }
  },
  bottom: {
    options: {
      columnStart: a.leftEdge,
      columnEnd: a.rightEdge
    }
  },
  start: {
    lgOptions: {
      columnStart: a.leftEdge,
      columnEnd: e.inner3,
      rowStart: 2
    },
    xlOptions: {
      columnStart: a.leftEdge,
      columnEnd: e.inner4
    },
    twoXlOptions: {
      columnStart: a.leftEdge,
      columnEnd: e.inner3
    }
  },
  middle: {
    lgOptions: {
      columnStart: e.inner3,
      columnEnd: e.inner11,
      rowStart: 2,
      rowEnd: 3
    },
    xlOptions: {
      columnStart: e.inner4,
      columnEnd: e.inner10
    },
    twoXlOptions: {
      columnStart: e.inner3,
      columnEnd: e.inner11
    }
  },
  end: {
    lgOptions: {
      columnStart: e.inner11,
      columnEnd: a.rightEdge,
      rowStart: 2
    },
    xlOptions: {
      columnStart: e.inner10,
      columnEnd: a.rightEdge
    },
    twoXlOptions: {
      columnStart: e.inner11,
      columnEnd: a.rightEdge
    }
  }
}, _ = {
  first: {
    options: {
      columnStart: a.leftEdge,
      columnEnd: a.rightEdge,
      topSpacing: "8vw",
      bottomSpacing: "12vw",
      rowStart: 3
    },
    mdOptions: {
      topSpacing: "12vw"
    },
    lgOptions: {
      columnStart: e.inner3,
      columnEnd: e.inner11,
      topSpacing: "6vw",
      bottomSpacing: "none",
      rowStart: 3,
      rowEnd: 4
    },
    xlOptions: {
      columnStart: e.inner4,
      columnEnd: e.inner10,
      topSpacing: "8vw"
    },
    twoXlOptions: {
      columnStart: e.inner3,
      columnEnd: e.inner11,
      topSpacing: "12vw"
    }
  },
  second: {
    options: {
      columnStart: a.leftEdge,
      columnEnd: a.rightEdge,
      bottomSpacing: "12vw",
      rowStart: 4
    },
    lgOptions: {
      bottomSpacing: "none",
      columnStart: e.inner3,
      columnEnd: e.inner11,
      rowStart: 4,
      rowEnd: 5
    },
    xlOptions: {
      columnStart: e.inner4,
      columnEnd: e.inner10
    },
    twoXlOptions: {
      columnStart: e.inner3,
      columnEnd: e.inner11
    }
  }
}, P = [0, 1 / 3, 2 / 3, 1], ce = {
  start: ["0vw", "12.5vw", "25vw", "0vw"],
  end: ["0vw", "5vw", "10vw", "0vw"],
  middle: ["0", "0", "0", "0"],
  top: ["0", "0", "0", "0"],
  bottom: ["0", "0", "0", "0"]
}, pe = (s) => {
  if (s)
    return ["0", "0", "0", "0"];
  const n = 30;
  return P.map((l) => `-${l * n}vw`).reverse();
}, j = "ImageLane", g = new L(j), de = z(M), V = ({
  images: s,
  alignment: n,
  scrollYProgress: l,
  imageLoading: o = "lazy"
}) => {
  const m = X(
    l,
    P,
    ce[n],
    { ease: A }
  ), i = B(), w = y(
    g.getComponentClassName(),
    g.getPropsValueClassName("alignment", n)
  ), u = (c) => y(
    g.getElementClassName("item-title"),
    g.getPropsValueClassName("variant", c)
  );
  return /* @__PURE__ */ t(
    de,
    {
      ...ie[n],
      as: "ul",
      className: w,
      style: { y: m, willChange: i },
      children: s.map(({ logo: c, headline: N, image: r, variant: h }) => /* @__PURE__ */ f(
        U,
        {
          as: "li",
          className: g.getElementClassName("item"),
          motionOptions: J,
          children: [
            /* @__PURE__ */ f("div", { className: u(h), children: [
              c && /* @__PURE__ */ t(
                R,
                {
                  ...c,
                  className: g.getElementClassName("item-title-icon"),
                  loading: o,
                  dimensions: {}
                }
              ),
              /* @__PURE__ */ t(G, { as: "p", size: "Title", children: N })
            ] }),
            /* @__PURE__ */ t(
              R,
              {
                ...r,
                baseImage: r.baseImage,
                mdImage: r.baseImage,
                desktopImage: r.desktopImage ?? r.mdImage,
                className: g.getElementClassName(
                  "item-background-image"
                ),
                loading: o
              }
            )
          ]
        },
        N
      ))
    }
  );
};
V.displayName = j;
const ge = (s, n) => {
  const o = [n.replace("_", "-")];
  try {
    const m = Intl.NumberFormat.supportedLocalesOf(o, {
      localeMatcher: "lookup"
    });
    if (!m.length)
      throw new Error("Locales not supported");
    return new Intl.NumberFormat(m).format(s);
  } catch {
    return s.toString();
  }
}, D = "ScrollNumber", p = new L(D), x = ({
  numberStart: s,
  numberEnd: n,
  prefix: l,
  suffix: o,
  textGroup: m
}) => {
  const i = F(null), { requestor: { locality: { locale: w = "en-US" } = {} } = {} } = K(), [u, c] = Z(), N = ["start end", "start center"], { scrollYProgress: r } = H({
    target: i,
    offset: N
  }), {
    headline: h = "",
    headlineSize: C = "Headline 1",
    headlineTag: v = "h1",
    ...b
  } = m, S = Array.from(
    { length: n - s + 1 },
    (E, d) => s + d
  ), O = 100 - 100 / S.length, { discreteOutput: I } = le({
    value: r,
    inputRange: [0, 1],
    outputRange: ["0%", `-${O}%`],
    splits: S.length
  }), T = Y(0);
  return ee(I, "change", (E) => {
    const d = me(E);
    d < T.get() && (T.set(d), c(u.current, { y: E })), d.toFixed(3) === (-O).toFixed(3) && I.clearListeners();
  }), /* @__PURE__ */ f("div", { className: p.getComponentClassName(), ref: i, children: [
    /* @__PURE__ */ f(
      G,
      {
        className: p.getElementClassName("slot-machine"),
        size: "Headline 4",
        as: v,
        children: [
          /* @__PURE__ */ f("span", { className: p.getElementClassName("number-range"), children: [
            l && /* @__PURE__ */ t("span", { className: p.getElementClassName("prefix"), children: l }),
            /* @__PURE__ */ t(
              "span",
              {
                className: p.getElementClassName("scroller"),
                ref: u,
                children: S.map((E, d) => /* @__PURE__ */ t(
                  "span",
                  {
                    "aria-hidden": d !== S.length - 1,
                    className: p.getElementClassName("scroller-item"),
                    children: ge(E, w)
                  },
                  E
                ))
              }
            ),
            o && /* @__PURE__ */ t("span", { className: p.getElementClassName("suffix"), children: o })
          ] }),
          /* @__PURE__ */ t(
            G,
            {
              className: p.getElementClassName("headline"),
              as: "span",
              size: C,
              children: /* @__PURE__ */ t(te, { as: "span", content: h })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ t(re, { ...b })
  ] });
};
x.displayName = D;
const ue = () => {
  const [s] = ne(["Below LG"]), n = se(), l = !(s || n), o = F(null), m = Y(1), { scrollYProgress: i } = H({
    target: o,
    offset: ["start center", "end center"]
  });
  return {
    isBelowLG: s,
    sectionRef: o,
    scrollYProgress: l ? i : m
  };
};
const Q = "ImageGridSection", $ = new L(Q), Ne = z(M), Se = ({
  headline: s,
  collection1: n,
  scrollNumber1: l,
  collection2: o,
  scrollNumber2: m,
  topSpacer: i = "6vw",
  bottomSpacer: w = "6vw",
  imageLoading: u,
  theme: c,
  componentId: N
}) => {
  const { isBelowLG: r, sectionRef: h, scrollYProgress: C } = ue(), v = X(
    C,
    P,
    pe(r),
    { ease: A }
  ), b = B(), [S, O] = W(
    k({
      isBelowLG: r,
      collection1: n,
      collection2: o
    })
  );
  return q(() => {
    O(
      k({
        isBelowLG: r,
        collection1: n,
        collection2: o
      })
    );
  }, [r, n, o]), /* @__PURE__ */ f(
    oe,
    {
      ref: h,
      id: N,
      theme: c,
      className: $.getComponentClassName(),
      options: {
        topSpacing: i,
        bottomSpacing: w,
        rowsGap: "none"
      },
      children: [
        /* @__PURE__ */ t(ae, { ...s, bottomSpacer: "12vw" }),
        S.map((I) => /* @__PURE__ */ t(
          V,
          {
            ...I,
            scrollYProgress: C,
            imageLoading: u
          },
          I.alignment
        )),
        /* @__PURE__ */ t(M, { ..._.first, children: /* @__PURE__ */ t(x, { ...l }) }),
        /* @__PURE__ */ t(
          Ne,
          {
            ..._.second,
            className: $.getElementClassName("distancing-scroll-number"),
            style: { y: v, willChange: b },
            children: /* @__PURE__ */ t(x, { ...m })
          }
        )
      ]
    }
  );
};
Se.displayName = Q;
export {
  Se as default
};
//# sourceMappingURL=ImageGridType.js.map
